import * as Utils from 'Assets/Utils'

import Immutable from 'immutable'
import ClientHttpRequest from "Api/ClientHttpRequest"
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({}).set('Get', new Immutable.List([]))

/* Types */
export const GET_JUSTIFICATION = 'GET_JUSTIFICATION'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_JUSTIFICATION:
			return state.set('Get', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */
export const setJustification = (form) => {

	const estadoEvaluacion = form.evaluacion.cuestionario.estadoEvaluacion

	let justificacion = form.justificaciones.map((j) => {

		let pregunta1_radio = j.preguntas[0].pregunta1_radio
		let pregunta1_observaciones = j.preguntas[0].pregunta1_observaciones
		let pregunta2_radio = j.preguntas[0].pregunta2_radio
		let pregunta2_observaciones = j.preguntas[0].pregunta2_observaciones

		return {
			idDonatariaRubro: j.id,
			idRubro: j.idRubro,
			preguntas: {
				pregunta: [{
					idPregunta: j.preguntas[0].id_pregunta_1,
					respuesta: pregunta1_radio === 'NO' ? false : true,
					observaciones: pregunta1_observaciones || null
				},
				{
					idPregunta: j.preguntas[0].id_pregunta_2,
					respuesta: pregunta2_radio === 'NO' ? false : true,
					observaciones: pregunta2_observaciones || null
				}]
			},
			justificacionRubro: true,
			montoJustificado: parseFloat(j.montoJustificado),
			montoSolicitado: null
		}
	})

	let temp = {
		idDonataria: form.idDonataria,
		idCorrida: form.idCorrida,
		justificacionRubros: {
			idEvaluacion: form.idEvaluacion,
			estadoEvaluacion,
			usuarioModifica : {
				idUsuario: sessionStorage.uid,
				nombreUsuario: `${sessionStorage.firstname} ${sessionStorage.lastname}`
			},
			preguntasGenerales: {
				pregunta: [{
					idPregunta: 1000,
					respuesta: form.congruenteRadio === 1 ? true : false,
					observaciones: form.congruente
				},
				{
					idPregunta: 1001,
					respuesta: form.solicitadoRadio === 1 ? true : false,
					observaciones: form.solicitado
				},
				{
					idPregunta: 1002,
					respuesta: form.identificadaRadio === 1 ? true : false,
					observaciones: form.identificada
				}]
			},
			justificaciones: { justificacion },
			revisionOtrasAreas: form.revisionRadio === 1 ? true : false,
			justificacionSolicitud: {
				id: form.justificacionSolicitud === "Completa" ? 1 : form.justificacionSolicitud === "Parcial" ? 2 : 3,
				descripcion: form.justificacionSolicitud
			},
			causaNoJustificacion: form.noJustificacion,
			comentario: ""
		}
	}

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setJustification',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then((response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const getJustification = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getJustification',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then((response) => {

			const data = response.data.justificacionRubros

			let justificaciones = []

			if (data.justificaciones.justificacion) {

				justificaciones = data.justificaciones.justificacion.map((j) => {

					let preguntas = [{
						id_pregunta_1: j.preguntas.pregunta[0].idPregunta,
						pregunta1_radio: j.preguntas.pregunta[0].respuesta ? 'SI' : 'NO',
						pregunta1_observaciones: j.preguntas.pregunta[0].observaciones,
						id_pregunta_2: j.preguntas.pregunta[1].idPregunta,
						pregunta2_radio: j.preguntas.pregunta[1].respuesta ? 'SI' : 'NO',
						pregunta2_observaciones: j.preguntas.pregunta[1].observaciones,
					}]

					return {
						id: j.idDonatariaRubro,
						idRubro: j.idRubro,
						rubro: j.descripcionRubro,
						concepto: j.concepto,
						montoSolicitado: j.montoSolicitado,
						montoJustificado: j.montoJustificado,
						justificacion: (j.preguntas.pregunta[0].respuesta && j.preguntas.pregunta[1].respuesta) ? 'SI' : 'NO',
						preguntas
					}
				})
			}

			let form = {
				idEvaluacion: data.idEvaluacion,
				congruenteRadio: data.preguntasGenerales.pregunta[0].respuesta ? 1 : 2,
				congruente: data.preguntasGenerales.pregunta[0].observaciones,
				solicitadoRadio: data.preguntasGenerales.pregunta[1].respuesta ? 1 : 2,
				solicitado: data.preguntasGenerales.pregunta[1].observaciones,
				identificadaRadio: data.preguntasGenerales.pregunta[2].respuesta ? 1 : 2,
				identificada: data.preguntasGenerales.pregunta[2].observaciones,
				justificaRadio: data.justifica ? 1 : 2,
				justificaciones: justificaciones,
				revisionRadio: data.revisionOtrasAreas ? 1 : 2,
				justificacionSolicitud: data.justificacionSolicitud.id === 1 ? "Completa" : data.justificacionSolicitud.id === 2 ? "Parcial" : "No justifica",
				noJustificacion: data.causaNoJustificacion || '',
				rubrosDonataria: data.justificaciones.justificacion
			}


			dispatch(isLoading(false))
			dispatch({ type: GET_JUSTIFICATION, Obj: form })
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const clearJustification = () => {
	return (dispatch) => {
		dispatch({ type: GET_JUSTIFICATION, Obj: {} })
	}
}




// WEBPACK FOOTER //
// ./src/modules/Grantees/Evaluation/Justification.js